import {
  blue25,
  blue100,
  blue135,
  blue180,
  fluorescentBlueViolet69,
  gray30,
  gray50,
  gray70,
  gray85,
  green25,
  green100,
  green157,
  green180,
  greenBlue75,
  greenBlue100,
  greenBlue135,
  greenBlue180,
  pink25,
  pink100,
  pink115,
  pink180,
  red25,
  red100,
  red135,
  red180,
  violet25,
  violet100,
  violet135,
  violet180,
  violetPinkDesat25,
  violetPinkDesat100,
  violetPinkDesat135,
  violetPinkDesat180,
} from '@spotify/confidence-encore-foundation';

export const SEMANTIC_COLORS = [
  'gray',
  'greenBlue',
  'green',
  'blue',
  'purple',
  'pink',
  'red',
  'violet',
  'fluorescentBlue',
] as const;

export type SemanticColor = (typeof SEMANTIC_COLORS)[number];

export type ColorCategory = 'text' | 'background';

type ColorMap = Record<SemanticColor, string>;

export const DARK_TEXT_COLORS: ColorMap = {
  gray: gray70,
  greenBlue: greenBlue135,
  green: green157,
  blue: blue135,
  purple: violet135,
  pink: pink115,
  red: red135,
  violet: violetPinkDesat135,
  fluorescentBlue: fluorescentBlueViolet69,
};

export const LIGHT_TEXT_COLORS: ColorMap = {
  gray: gray50,
  greenBlue: greenBlue100,
  green: green100,
  blue: blue100,
  purple: violet100,
  pink: pink100,
  red: red100,
  violet: violetPinkDesat100,
  fluorescentBlue: fluorescentBlueViolet69,
};

export const DARK_BG_COLORS: ColorMap = {
  gray: gray30,
  greenBlue: greenBlue75,
  green: green25,
  blue: blue25,
  purple: violet25,
  pink: pink25,
  red: red25,
  violet: violetPinkDesat25,
  fluorescentBlue: fluorescentBlueViolet69,
};

export const LIGHT_BG_COLORS: ColorMap = {
  gray: gray85,
  greenBlue: greenBlue180,
  green: green180,
  blue: blue180,
  purple: violet180,
  pink: pink180,
  red: red180,
  violet: violetPinkDesat180,
  fluorescentBlue: fluorescentBlueViolet69,
};

export type SemanticColorOption = {
  name: string;
  semanticName: SemanticColor;
};

export const SEMANTIC_COLOR_OPTIONS: SemanticColorOption[] = [
  { name: 'Gray', semanticName: 'gray' },
  { name: 'GreenBlue', semanticName: 'greenBlue' },
  { name: 'Green', semanticName: 'green' },
  { name: 'Blue', semanticName: 'blue' },
  { name: 'Purple', semanticName: 'purple' },
  { name: 'Pink', semanticName: 'pink' },
  { name: 'Red', semanticName: 'red' },
  { name: 'Violet', semanticName: 'violet' },
  { name: 'Fluorescent Blue', semanticName: 'fluorescentBlue' },
];
